export const getValueFromQueryParams = (queryString, value) => new URLSearchParams(queryString).get(value);
